import { render } from "./Licenses.vue?vue&type=template&id=3212176a&scoped=true&ts=true"
import script from "./Licenses.vue?vue&type=script&lang=ts"
export * from "./Licenses.vue?vue&type=script&lang=ts"

import "./Licenses.vue?vue&type=style&index=0&id=3212176a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c14bfaf61e4aff3d2996531c89f90cfb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3212176a"]])

export default __exports__